<template>
  <div class="z2-conversation-header border-bottom">
    <img
      class="z2-avatar mb-1 pointer"
      :src="conversation?.avatar || '/assets/images/no-avatar.png'"
      @click="onShowProfile" />
    <div class="d-flex flex-grow-1 flex-column mb-1 ms-2">
    <!-- TÊN -->
    <div class="d-flex align-items-center">
      <span
        class="font-16 fw-500 me-1 trim-text-1-line"
        :style="{ maxWidth: nameMaxWidth }"
      >
        {{ conversation.swName && conversation.swName.length > 0
          ? conversation.swName
          : conversation.toName }}
      </span>
      <div @click="showPopOver">
        <IconV2 class="pointer" name="v2-edit" />
      </div>
    </div>

    <!-- ⭐ HÀNG MỚI: SCORE -->
    <div
      v-if="hasScore"
      class="d-flex align-items-center score"
      style="line-height: 1; padding: 2px 0"
      @click="handleClickAnalyze()"
    >
      <i
        v-for="i in 10"
        :key="i"
        class="fa-star"
        :class="i <= fullStars
          ? 'fa-solid text-warning'
          : 'fa-regular text-muted'"
      />
      <span class="ms-1 text-muted">({{ score }}/10)</span>
    </div>

    <!-- LAST ONLINE / MEMBERS -->
    <span
      v-if="!conversation.group"
      class="font-14 fw-300"
    >
      {{ onlineStatus.lastOnlineStr }}
    </span>
    <span v-else class="font-14 fw-300">
      {{ members.length }} thành viên
    </span>
  </div>
    <div v-if="showAIIcon" class="d-flex align-items-center ms-2 mb-1 ai-tags" @click="handleClickAnalyze()">
      <div class="logo-container-sm">
        <el-tooltip
        v-if="analysisData.id"
        content="✨ AI phân tích"
        placement="top"
      >
        <div class="logo-container-sm">
          <!-- <div class="logo-text-sm">SALEWORK</div> -->

          <div class="ai-icon-img-sm">
            <img
              src="/assets/icon/AI3.png"
              alt="AI Icon"
            />
          </div>
        </div>
      </el-tooltip>
      </div>
      <!-- <div class="d-flex flex-wrap gap-1 ms-2 ai-tag-list" v-if="tagParse.length > 0">
        <span
          v-for="(tag, index) in tagParse.slice(0, 1)"
          :key="index"
          class="ai-badge"
          :style="{ background: randomGradient() }"
        >
          {{ tag }}
        </span>

        <el-tooltip
          v-if="tagParse.length > 1"
          :content="tagParse.slice(1).join(', ')"
          placement="top"
        >
          <span class="ai-badge more-badge">+{{ tagParse.length - 1 }}</span>
        </el-tooltip>
      </div> -->
    </div>
    <!-- <div v-else-if="showAIIconAnalysis">
      <div v-if="!polling" class="logo-container-sm me-1" @click="analysisConversaiton()">
        <el-tooltip
          content="Phân tích ngay"
          placement="top"
        >
          <div class="logo-container-sm">
            <div class="ai-icon-img-sm">
              <img
                src="/assets/icon/AI3.png"
                alt="AI Icon"
              />
            </div>
          </div>
        </el-tooltip>
      </div>
      <div v-else class="logo-container-sm">
        <IconV2 name="el-icon-loading"></IconV2>
      </div>
    </div> -->
    <!-- <div
      v-else-if="!conversation.group && !isSearch"
      class="d-flex align-items-center ms-2 ai-analyze-btn pointer"
      @click="clickToAnalyze()"
    >
      <el-tooltip content="Phân tích AI" placement="top">
        <img
          src="/assets/icon/google-gemini-icon.webp"
          width="20"
          height="20"
          class="ai-icon"
        />
      </el-tooltip>
      <span class="ms-1 font-12">Bắt đầu phân tích</span>
    </div> -->
    <div class="mb-1 d-flex align-items-center">
      <el-input
        v-if="isSearch"
        :value="searchKey"
        @input="changeSearchKey"
        size="small"
        class="input-radius"
        style="width: 300px"
        placeholder="Tìm tin nhắn trong hội thoại"
        @keydown.enter.exact.native="onSearchMessage"
        >
        <div
          slot="suffix"
          class="mt-1 d-flex align-items-center justify-content-center pointer"
          style="width: 24px; height: 24px; background-color: #eff5ff; border-radius: 12px"
          @click="isSearch = false">
          <IconV2
            name="v2-search"
            color="#3484F0" />
        </div>
      </el-input>
      <div
        v-else
        class="pointer"
        @click="isSearch = true">
        <IconV2
          name="v2-search"
          size="lg" />
      </div>

      <div
        class="rounded z2-button-filter"
        @click="conversation.unreadCount ? unread(conversation.id) : setRead(conversation.id)">
        <el-tooltip
          effect="dark"
          :content="'Đánh dấu chưa đọc'"
          placement="top">
          <IconV2
            :name="conversation.unreadCount ? 'v2-read' : 'v2-unread'"
            size="lg" />
        </el-tooltip>
      </div>
      <div
        class="z2-btn z2-btn-circle"
        @click="onExpandConversation">
        <i
          class="font-16 fw-bold"
          :class="isExpand ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
      </div>
      <div class="ms-1" @click="handleCloseConversation" style="cursor: pointer;">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <el-dialog
      :title="'Đặt biệt danh cho ' + conversation.toName"
      width="400px"
      v-if="showPopOverSwName"
      :visible.sync="showPopOverSwName"
      destroy-on-close>
      <div>
        <el-input
          placeholder="Nhập biệt danh"
          type="textarea"
          :rows="3"
          v-model="conversation.swName"
          @keydown.enter.exact.native="saveSwName"
          resize="none"></el-input>
        <div class="d-flex justify-content-end mt-2">
          <el-button
            type="primary"
            size="mini"
            plain
            @click="saveSwName()">
            Lưu
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      v-if="showProfile && profile && !conversation.group"
      width="300px"
      :visible.sync="showProfile"
      title="Thông tin tài khoản"
      class="dialogProfileV2">
      <div
        slot="title"
        class="font-16 fw-500">
        Thông tin tài khoản
      </div>
      <ProfileInfoPopupV2
        :data="profile"
        :conversation="conversation"
        @closeProfile="closeProfile" />
    </el-dialog>

    <el-dialog
      v-if="showProfile && conversation.group"
      width="360px"
      :visible.sync="showProfile"
      title="Thông tin nhóm"
      :destroy-on-close="true">
      <GroupInfoPopup
        :members="members.length"
        :avatar="conversation.avatar || '/assets/images/no-avatar.png'"
        :name="conversation.toName"
        :closeGroupInfoPopup="showProfile"
        :idConversationGroup="conversation" />
    </el-dialog>
  </div>

  <!-- <div>Chặn</div> -->
  <!-- <div>Ket ban</div> -->
  <!-- <div>Ghim</div> -->
  <!-- <div>Dialog Giao viec</div> -->
  <!-- <div>Dialog Thong tin nhom</div> -->
  <!-- <div>Dialog profile</div> -->
  <!-- <div>Dialog Lich su gan tag</div> -->
  <!-- <div>Dialog Tao nhom</div> -->
  <!-- <div>Dialog Them thanh vien</div> -->
  <!-- <div>Dialog Dat biet danh</div> -->
</template>

<script>
import IconV2 from "./common/IconV2.vue";
import ProfileInfoPopupV2 from "./ProfileInfoPopupV2";
import GroupInfoPopup from "@/components/GroupInfoPopup";

export default {
  props: ["conversation", "onlineStatus", "isExpand", "profile", "members", "searchKey", "analysisData", "analysisDataLastest"],
  components: {
    IconV2,
    ProfileInfoPopupV2,
    GroupInfoPopup,
  },
  data() {
    return {
      showPopOverSwName: false,
      showProfile: false,
      isSearch: false,
      pollingTimeout: null,
      retryCount: 0,
      maxRetry: 10,
      isPolling: false,
      analysisResult: null
    };
  },
  methods: {
    async analysisConversaiton() {
      this.isPolling = true;
      try {
        this.$http.post("/api/ai/execute", {
          action: "handleConversation",
          conversationId: this.conversation.id
        });
        this.$message.success("Đang tiến hành phân tích hội thoại...");

        this.retryCount = 0;
        this.pollResult();
      } catch (err) {
        console.error("Error:", err);
        this.$message.error("Phân tích hội thoại thất bại.");
      }
    },
    async pollResult() {
      if (this.retryCount >= this.maxRetry) {
        this.stopPolling();
        return;
      }

      this.retryCount++;
      try {
        const phone = this.formatPhone(
          this.conversation?.phone || this.conversation.id
        );

        const res = await this.$http.post("/api/ai/execute", {
          action: "conversationInfo",
          data: {
            phone: phone,
            conversationId: this.conversation.id
          }
        });

        const status = JSON.parse(res.data).data.data.aiConversationSummaryCurrent?.analysisStatus || 'FOUL';

        const createdTime = new Date(JSON.parse(res.data).data.data.aiConversationSummaryCurrent.createAt).getTime();
        const now = Date.now();
        const diffInMs = now - createdTime;
        const oneHour = 60 * 60 * 1000;

        if (status === "COMPLETE" && diffInMs <= oneHour) {
          this.$emit('analysisResult', {analysisData: JSON.parse(res.data).data.data.aiConversationSummaryCompleted, analysisDataLastest: JSON.parse(res.data).data.data.aiConversationSummaryCurrent});
          this.$message.success("Phân tích thành công.");
          this.stopPolling();
          return;
        } else if (status === "NO_MESSAGE" && (this.retryCount >= this.maxRetry || diffInMs <= oneHour)) {
          this.$emit('analysisResult', {analysisData: JSON.parse(res.data).data.data.aiConversationSummaryCompleted || JSON.parse(res.data).data.data.aiConversationSummaryCurrent, analysisDataLastest: JSON.parse(res.data).data.data.aiConversationSummaryCurrent});
          this.$message.error("Hôm nay chưa phát sinh tin nhắn cho hội thoại này.");
          this.stopPolling();
          return;
        } else if (status === "LIMIT_REACHED") {
          this.$message.error("Hôm nay đã đạt giới hạn phân tích.");
          this.stopPolling();
          return;
        }

      } catch (e) {
        console.error("Polling error:", e);
        // this.stopPolling();
      }
      this.pollingTimeout = setTimeout(() => {
        this.pollResult();
      }, 5000);
    },
    stopPolling() {
      if (this.pollingTimeout) {
        clearTimeout(this.pollingTimeout);
        this.pollingTimeout = null;
        this.isPolling = false;
        this.handleClickAnalyze();
        this.$bus.$emit('analysisNewDone');
      }
    },
    formatPhone(phone) {
      if (!phone) return "";

      // bỏ khoảng trắng, dấu chấm, dấu cách
      phone = phone.replace(/[^\d+]/g, "");

      // +84xxxx → 0xxxx
      if (phone.startsWith("+84")) {
        return "0" + phone.substring(3);
      }

      // 84xxxx → 0xxxx
      if (phone.startsWith("84")) {
        return "0" + phone.substring(2);
      }

      return phone;
    },
    handleClickAnalyze() {
      this.$emit("onClickAnalyze");
    },
    clickToAnalyze() {
      this.$http.get('/api/conversation/pushToAnalysis?conversationId=' + this.conversation.id + '&accountId=' + this.conversation.accountId);
      this.$message.success("Vui lòng đợi trong ít phút.");
    },
    randomGradient() {
      const c1 = `hsl(${Math.floor(Math.random() * 360)}, 70%, 50%)`;
      const c2 = `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`;
      return `linear-gradient(135deg, ${c1}, ${c2})`;
    },
    onExpandConversation() {
      this.$emit("onClickExpand");
    },
    showPopOver() {
      this.showPopOverSwName = true;
    },
    saveSwName() {
      const payload = {
        accountId: this.conversation.accountId,
        conversationId: this.conversation.id,
        swName: this.conversation.swName
      }
      this.$http.post("/api/conversation/setSwName", payload);
      this.showPopOverSwName = false;
      this.$bus.$emit("swNameUpdated", this.conversation);
    },
    onShowProfile() {
      if (!this.conversation.page) {
        this.showProfile = true;
      }
    },
    closeProfile() {
      this.showProfile = false;
    },
    changeSearchKey(e) {
      this.$emit("changeSearchKey", e);
    },
    onSearchMessage() {
      this.$emit('onSearchMessage')
    },
    handleCloseConversation() {
      this.$emit('closeConversation');
    }
  },
  computed: {
    showAIIconAnalysis() {
      return !this.conversation.group && this.showAnalysisIcon && !this.isSearch && this.app.aiService !== 'none';
    },
    showAnalysisIcon() {
      if (!this.analysisDataLastest?.createAt) return true;

      const createdTime = new Date(this.analysisDataLastest.createAt).getTime();
      const now = Date.now();

      const diffInMs = now - createdTime;

      const oneHour = 60 * 60 * 1000;

      return diffInMs >= oneHour;
    },
    showAIIcon() {
      return !this.conversation.group && this.analysisData?.id && !this.isSearch && this.app.aiService !== 'none';
    },
    polling() {
      return this.isPolling;
    },
    score() {
      return this.app.pointConversation?.[this.conversation.id]?.satisfactionScore ?? null;
    },
    hasScore() {
      return this.score !== null && this.app.aiService !== 'none';
    },
    fullStars() {
      return Math.floor(this.score || 0);
    },
    hasHalfStar() {
      return this.score !== null && this.score % 1 >= 0.5;
    },
    scoreClass() {
      if (this.score >= 8) return 'score-high';
      if (this.score >= 5) return 'score-mid';
      return 'score-low';
    },
    tagParse() {
      try {const parsed = JSON.parse(this.analysisData.tags)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    },
    nameMaxWidth() {
      const hasSearchOrTag = this.isSearch

      if (hasSearchOrTag) {
        return this.isExpand
          ? 'calc(100vw - 1100px)'
          : 'calc(100vw - 900px)'
      }

      return this.isExpand
        ? 'calc(100vw - 900px)'
        : 'calc(100vw - 600px)'
    }
  },
  mounted() {
    this.$bus.$on('analysisNew', () => this.analysisConversaiton());
  },
  beforeDestroy() {
    this.stopPolling();
  },
};
</script>

<style lang="scss">
.dialogProfileV2 {
  .el-dialog__body {
    padding: 0 !important;
  }
}
.input-radius {
  input {
    border-radius: 1rem;
  }
}
</style>

<style scoped>
.ai-tags {
  padding: 4px 8px;
  border-radius: 16px;
  cursor: pointer;
}

.ai-icon {
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(79, 172, 254, 0.7);
}

.ai-badge {
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  border-radius: 12px;
  padding: 2px 8px;
  line-height: 1.4;
  display: inline-block;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2); /* giúp nổi khối */
}

.more-badge {
  background: #666 !important; /* badge +X khác biệt */
  cursor: pointer;
}

.ai-tag-list {
  max-width: 200px;          /* 🔥 chỉnh theo UX mong muốn */
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  flex-wrap: nowrap;         /* ❗ không cho đẩy layout */
  gap: 4px;
}

/* mỗi badge nếu dài thì ... */
.ai-badge {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ai-analyze-btn {
  padding: 4px 8px;
  border-radius: 6px;
  background: #f5f7fa;
}

.ai-analyze-btn:hover {
  background: #e6f0ff;
}

.logo-container-sm {
  display: inline-flex;
  align-items: center;
  flex-direction: row; /* TEXT LEFT - ICON RIGHT */
  gap: 0.4rem;
}

/* ICON */
.ai-icon-img-sm {
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.ai-icon-img-sm img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0.9;
}

/* HOVER EFFECT */
.logo-container-sm:hover .ai-icon-img-sm {
  transform: scale(1.12);
}

/* ANIMATION */
@keyframes metallic-sm {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.score-badge {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* màu theo score */
.score-high {
  background-color: #22c55e; /* xanh lá */
}

.score-mid {
  background-color: #f59e0b; /* cam */
}

.score-low {
  background-color: #ef4444; /* đỏ */
}
.score-high {
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(34,197,94,.6); }
  70% { box-shadow: 0 0 0 6px rgba(34,197,94,0); }
  100% { box-shadow: 0 0 0 0; }
}

.score {
  cursor: pointer;
}
</style>